<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>Kissing Lessons</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Susan Laine</p>
<p class="P_Norm-NoIndent">A Before… and After Story</p>
<p class="P_Normal"> </p>
<p class="P_Normal">A kiss is just a kiss. It doesn’t have to mean anything. Does it?</p>
<p class="P_Normal">At seventeen, Merry’s never been kissed. Since he doesn’t want to disappoint his prom date, he asks his more experienced best friend, Boone, for some pointers. Surprisingly, Boone agrees to give him a hands-on lesson.</p>
<p class="P_Normal">But they have no idea what they’re getting into.</p>
<p class="P_Normal">They explore hundreds of ways to make out, but somehow it isn’t enough. A week later, they’re back together for another session. This time things go further than either of them planned, and their relationship becomes awkward and uncomfortable.</p>
<p class="P_Normal">Have they learned enough to salvage their friendship <span style=" font-style: italic; font-size: 1.00em;">and</span> help it evolve? Their lessons have come to an end. They can either part ways forever… or share a true love’s kiss.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?edb07e5e